function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#backspace_path0_fill",
  transform: "translate(.2 .96)"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#backspace_path1_fill",
  transform: "translate(14.28 7.14)",
  fill: "#B2B2B2"
});

var _ref4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#backspace_path2_fill",
  transform: "translate(14.23 7.1)",
  fill: "#B2B2B2"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "backspace_path0_fill",
  d: "M27 0H10.1a.908.908 0 00-.7.3L.3 9.4a1.088 1.088 0 000 1.5L9.4 20c.189.182.438.289.7.3h16.8a1.367 1.367 0 001.4-1.4V1.4A1.344 1.344 0 0027 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "backspace_path1_fill",
  d: "M.825 8.229a1.421 1.421 0 01-.6-.2.913.913 0 010-1.2l6.6-6.6a.849.849 0 011.2 1.2l-6.6 6.6c-.183.11-.388.18-.6.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "backspace_path2_fill",
  d: "M7.469 8.269a1.42 1.42 0 01-.6-.2l-6.6-6.6a.85.85 0 111.2-1.2l6.6 6.6a.913.913 0 010 1.2.845.845 0 01-.6.2z"
}));

function SvgBackspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.3afd1395.svg";
export { ForwardRef as ReactComponent };